export class FondsDetailConverters {
  constructor() {
  }

  createList(data) {
    let list = '';
    data.forEach(item => {
      if (item !== '' && item !== ' ') {
        list += `<li>${item}</li>`;
      }
    });
    return list;
  }

  cleanString(string) {
    return string.replace(/ /g, '_')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ö/g, 'oe')
      .replace(/ß/g, 'ss')
      .toLowerCase();
  }

  convertChartTitle(string) {
    return string.replace(/ /g, '')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ö/g, 'oe')
      .replace(/ß/g, 'ss')
      .replace(/10/g, '')
      .replace(/5/g, '')
      .toLowerCase();
  }

  percent(value) {
    if (value) {
      return ((value).toFixed(3) + ' %').replace('.', ',');
    }

    return value;
  }

  percentTwoDigits(value) {
    if (value || value === 0) {
      return ((value.toFixed(2)) + ' %').replace('.', ',');
    }

    return value;
  }

  percentTwoDigitsFromFloat(value) {
    if (value) {
      return (((value * 100).toFixed(2)) + ' %').replace('.', ',');
    }

    return value;
  }

  percentThreeDigits(value) {
    if (value) {
      return ((value).toFixed(3) + ' %').replace('.', ',');
    }

    return value;
  }

  float(value) {
    if (value) {
      return (value).toFixed(2).replace('.', ',');
    }

    return value;
  }

  deNumber(value) {
    if (value) {
      value = '' + value;
      if (value.length > 3) {
        var mod = value.length % 3;
        var output = (mod > 0 ? (value.substring(0, mod)) : '');
        for (var i = 0; i < Math.floor(value.length / 3); i++) {
          if ((mod === 0) && (i === 0)) {
            output += value.substring(mod + 3 * i, mod + 3 * i + 3);
          } else {
            output += '.' + value.substring(mod + 3 * i, mod + 3 * i + 3);
          }
        }
        return (output);
      }
    }

    return value;
  }

  euroAfterValue(value) {
    if (value) {
      value = parseFloat(value);
      return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }

    return value;
  }

  euroAfterValueNoCent(value) {
    if (value) {
      value = parseFloat(value);
      value = value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      return value.replace(',00', '');
    }

    return value;
  }

  euroFromFloat(value) {
    if (value) {
      return (value.toFixed(2) + ' EUR').replace('.', ',');
    } else if(value === '0' || value === '00' || value === 0) {
      return '0,00 EUR';
    }

    return value;
  }

  fondsValue(value) {
    // console.log(value);
    if (value) {
      value = value / 1000000;
      // console.log(value);
      return (value.toFixed(2) + ' Mio. EUR').replace('.', ',');
    }

    return value;
  }

  digitsFromFloat(value) {
    if (value) {
      return (value.toFixed(2) + '').replace('.', ',');
    }

    return value;
  }

  years(value) {
    if (value) {
      return (value.toFixed(2)).replace('.', ',') + ' Jahre';
    }

    return value;
  }

  sqlTimeToDate(value) {
    if (value) {
      return moment(value).utc().format('DD.MM.YYYY');
    }

    return value;
  }

  sqlTimeToDateNoYear(value) {
    if (value) {
      return moment(value).utc().format('DD.MM.');
    }

    return value;
  }

  crToBr(value) {
    if (value) {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    return value;
  }

  timerange(value, range, unit) {
    if (value) {
      return moment(value).subtract(range, unit).utc().format('DD.MM.YYYY') + ' – ' + moment(value).utc().format('DD.MM.YYYY');
    }

    return value;
  }

  timerange1m(value) {
    return timerange(value, 1, 'M');
  }

  timerange3m(value) {
    return timerange(value, 3, 'M');
  }

  timerange6m(value) {
    return timerange(value, 6, 'M');
  }

  timerangeKj(value) {
    return timerange(value, 1, 'Y');
  }

  timerange1y(value) {
    return timerange(value, 1, 'Y');
  }

  timerange3y(value) {
    return timerange(value, 3, 'Y');
  }

  timerange5y(value) {
    return timerange(value, 5, 'Y');
  }

  timerange10y(value) {
    return timerange(value, 10, 'Y');
  }

  topFondsCategoryName(value) {
    return value.split('-')[0];
  }

  topFondsCategoryValue(value) {
    return value;
  }

  cleanTopFonds(value) {
    if (value) {
      return value.replace('Top', '');
    }

    return value;
  }

  firstLetterUppercase(value) {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    return value;
  }

  cleanString(value) {
    if (value) {
      const element = document.createElement('div');
      element.innerHTML = value;
      return element.textContent;
    }

    return value;
  }

  kpi(value) {
    if (value) {
      return parseFloat(value).toFixed(2).replace('.', ',');
    }

    return value;
  }
}
